import CheckBox from '../formItems/checkBox';
import { MRT_Row } from 'material-react-table';

export interface IGridRowSelectorCellProps<T> {
	testId: string;
	row: MRT_Row<T>;
	onRowCheckboxClick?: (row: MRT_Row<T>, event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const GridRowSelectorCell = <T extends { id: number }>(props: IGridRowSelectorCellProps<T>): React.ReactElement => {
	return (
		<div
			onDoubleClick={e => e.stopPropagation()}
			onClick={event => {
				event.stopPropagation();
				if (props.onRowCheckboxClick) {
					props.onRowCheckboxClick(props.row, event);
				} else {
					props.row.toggleSelected(!props.row.getIsSelected());
				}
			}}
			style={{ textAlign: 'center' }}
		>
			<CheckBox testId={`${props.testId}-row-checkbox`} checked={props.row.getIsSelected()} />
		</div>
	);
};

export default GridRowSelectorCell;
